import React from "react";
import ToolTipComponent from "../ToolTipComponent";
import useMobile from "../../../hooks/useMobile";

export default function Radio({
  name,
  id,
  required,
  titleRus,
  message,
  options,
  value,
  onChange,
  onBlock,
  ...props
}) {
  const isMobile = useMobile();

  const handleChange = (e) => {
    if (onBlock) return;
    onChange(e.target.value);
  };

  return (
    <div
      id={id}
      className={`form-group ${isMobile ? "form-group-vertical" : ""}`}
    >
      {titleRus && (
        <div className="label-group">
          <label
            htmlFor={id}
            className={`text-s ${required ? `required_${required}` : ""}`}
          >
            {titleRus}
          </label>
          {message && (
            <ToolTipComponent text={message}>
              <div className="icon icon-center help-icon"></div>
            </ToolTipComponent>
          )}
        </div>
      )}

      <div className="input-items input-items_radio">
        {Object.keys(options)?.length > 0 && (
          <div className="checkbox-item">
            {Object.entries(options).map(([optionLabel, optionValue]) => (
              <React.Fragment key={optionValue}>
                <input
                  type="radio"
                  id={`${name}_${optionValue}`}
                  name={name}
                  value={optionValue}
                  checked={value.toString() === optionValue.toString()}
                  onChange={handleChange}
                  {...props}
                  className={`text-m
                    ${onBlock ? "input-blocked" : ""}
                  `}
                />
                <label htmlFor={`${name}_${optionValue}`}>{optionLabel}</label>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
